var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    attrs: {
      data: _vm.mappedInvoices,
      columns: _vm.columns,
      pagination: _vm.pagination,
      "rows-per-page-options": _vm.rowsPerPageOptions,
      "row-key": "id",
      "table-class": "invoice-table",
      "hide-header": "",
      "hide-bottom": "",
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "body-cell-invoice_number",
        fn: function(props) {
          return _c(
            "q-td",
            { attrs: { props: props } },
            [
              props.row.status.value !== "draft"
                ? _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: {
                          name: "invoice",
                          params: {
                            invoice: props.row.id,
                            teamId: _vm.activeTeam.id
                          }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(props.row.invoice_number) + "\n    "
                      )
                    ]
                  )
                : _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: {
                          name: "edit-invoice",
                          params: {
                            invoice: props.row.id,
                            teamId: _vm.activeTeam.id
                          }
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.$t("draft")) + "\n    ")]
                  )
            ],
            1
          )
        }
      },
      {
        key: "body-cell-created_at",
        fn: function(props) {
          return _c("q-td", { attrs: { props: props } }, [
            _c(
              "span",
              [
                _vm._v(
                  "\n      " + _vm._s(props.row.created_at_text) + "\n\n      "
                ),
                _c(
                  "q-tooltip",
                  {
                    attrs: {
                      anchor: "top middle",
                      self: "bottom middle",
                      delay: 300,
                      offset: [0, 5]
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.created_at_date) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        }
      },
      {
        key: "body-cell-status",
        fn: function(props) {
          return _c(
            "q-td",
            { attrs: { props: props } },
            [
              _c("status-chip", {
                attrs: {
                  status: props.row.status.value,
                  committed: props.row.committed_at !== null,
                  color: props.row.status.color,
                  clickable: _vm.user.isUserOfActiveTeam(),
                  small: ""
                },
                on: {
                  cancel: function($event) {
                    _vm.handleCancelInvoice(props.row.id)
                  },
                  paid: function($event) {
                    _vm.handleMarkInvoiceAsPaid(props.row.id)
                  },
                  open: function($event) {
                    _vm.handleMarkInvoiceAsOpen(props.row.id)
                  }
                }
              })
            ],
            1
          )
        }
      },
      {
        key: "body-cell-actions",
        fn: function(props) {
          return _c(
            "q-td",
            { attrs: { props: props } },
            [
              _c(
                "q-btn",
                {
                  attrs: {
                    icon: "more_vert",
                    color: "grey-7",
                    flat: "",
                    round: "",
                    dense: ""
                  }
                },
                [
                  _c(
                    "q-popover",
                    [
                      _c(
                        "q-list",
                        { staticClass: "no-border", attrs: { link: "" } },
                        [
                          props.row.status.value !== "draft"
                            ? _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$router.push({
                                        name: "invoice",
                                        params: {
                                          team: _vm.activeTeam.id,
                                          invoice: props.row.id
                                        }
                                      })
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: "visibility" }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t("display") }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          props.row.committed_at === null
                            ? _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$router.push({
                                        name: "edit-invoice",
                                        params: {
                                          team: _vm.activeTeam.id,
                                          invoice: props.row.id
                                        }
                                      })
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: "edit" }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t("edit") }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          props.row.status.value !== "draft"
                            ? _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.handlePdfDownload(
                                        props.row.id,
                                        props.row.invoice_number
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: { icon: "cloud_download" }
                                  }),
                                  _c("q-item-main", {
                                    attrs: { label: _vm.$t("download_pdf") }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          [
                            props.row.type !== "imported_invoice"
                              ? _c(
                                  "q-item",
                                  {
                                    directives: [
                                      {
                                        name: "close-overlay",
                                        rawName: "v-close-overlay"
                                      }
                                    ],
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.handleCopy(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: "file_copy" }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t("duplicate") }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          props.row.committed_at === null &&
                          props.row.status.value !== "draft"
                            ? [
                                _c("q-item-separator"),
                                _c(
                                  "q-item",
                                  {
                                    directives: [
                                      {
                                        name: "close-overlay",
                                        rawName: "v-close-overlay"
                                      },
                                      { name: "is-user", rawName: "v-is-user" }
                                    ],
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.handleCommit(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-item-side", {
                                      attrs: { icon: "lock" }
                                    }),
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t("commit") }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }